var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.664,
    height: 21.657,
    viewBox: "0 0 19.664 21.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3d7170;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.832,21.657A2.759,2.759,0,0,0,12.64,18.95H7.024A2.759,2.759,0,0,0,9.832,21.657Zm9.454-6.333c-.848-.878-2.435-2.2-2.435-6.526a6.749,6.749,0,0,0-5.616-6.563V1.354a1.4,1.4,0,0,0-2.807,0v.882A6.749,6.749,0,0,0,2.813,8.8c0,4.327-1.587,5.648-2.435,6.526A1.3,1.3,0,0,0,0,16.243,1.38,1.38,0,0,0,1.409,17.6H18.255a1.38,1.38,0,0,0,1.409-1.354A1.3,1.3,0,0,0,19.286,15.325Z",
    transform: "translate(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.66496de15eb44e317705eee99391165c.svg";
export { ForwardRef as ReactComponent };